import formatMonthKey from './formatMonthKey';
import type { ShiftMonthKeyParams } from '../types';

const shiftMonthKey = ({ month, delta }: ShiftMonthKeyParams): string => {
    const [yearText, monthText] = month.split('-');
    const date = new Date(Date.UTC(Number(yearText), Number(monthText) - 1 + delta, 1));
    return formatMonthKey({ date });
};

export default shiftMonthKey;
